import { useEffect, useState } from 'react';

import { useAuthentication } from '@givebacks/api';
import { ButtonMantine, ThemeIcon } from 'ui';
import { CollapsibleCard } from 'ui/Core';
import { IconCircleCheck } from 'ui/Icons';

import { User, useUserData } from '../../../api';
import { SignInForm } from '../../Forms/SignInForm';
import { CreateAccountForm } from './CreateAccount';

interface Props {
  initialEmail?: string;
  cause_uuid?: string;
  isCardExpanded?: boolean;
  onComplete: (user: User) => void;
  isEmailDisabled?: boolean;
}

export const UserAuthCard = ({
  initialEmail,
  cause_uuid,
  isCardExpanded,
  onComplete,
  isEmailDisabled,
}: Props) => {
  const { data: user } = useUserData();
  const { isAuthenticated } = useAuthentication();
  const [isSignUp, setIsSignUp] = useState(true);

  useEffect(() => {
    // We would not want to send this if only one of the 2 queries populated
    if (isAuthenticated && user) {
      onComplete(user);
    }
  }, [user, isAuthenticated]);

  return (
    <CollapsibleCard
      isCardExpanded={isAuthenticated ? false : isCardExpanded}
      headerTitle={isSignUp ? 'Create An Account' : 'Sign In'}
      endAdornment={
        isAuthenticated ? (
          <ThemeIcon size={'xl'} c="mint.7" p={0} bg="transparent">
            <IconCircleCheck />
          </ThemeIcon>
        ) : (
          <ButtonMantine variant="subtle" size="sm" onClick={() => setIsSignUp(!isSignUp)}>
            {isSignUp ? 'Sign In' : 'Create an Account'}
          </ButtonMantine>
        )
      }
    >
      {isSignUp ? (
        <CreateAccountForm
          cause_uuid={cause_uuid}
          initialEmail={initialEmail}
          onSuccess={(user: User) => {
            onComplete(user);
          }}
          toggleSignIn={() => setIsSignUp(false)}
          isEmailDisabled={isEmailDisabled}
          signInButton={(onClick, isLoading) => (
            <ButtonMantine variant="gradient" onClick={onClick} disabled={isLoading}>
              Create Account
            </ButtonMantine>
          )}
        />
      ) : (
        <SignInForm
          initialEmail={initialEmail}
          onSuccess={(user: User) => {
            onComplete(user);
          }}
        />
      )}
    </CollapsibleCard>
  );
};
